/*!
 * Lucide static icons v1.48.0 — https://lucide.dev
 * SVG geometry from the official package; rendered locally without a runtime.
 * ISC License
 *
 * Copyright (c) 2026 Lucide Icons and Contributors
 *
 * Permission to use, copy, modify, and/or distribute this software for any
 * purpose with or without fee is hereby granted, provided that the above
 * copyright notice and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
 * WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
 * ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
 * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
 * ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
 * OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 *
 * ---
 *
 * The following Lucide icons are derived from the Feather project:
 *
 * airplay, alert-circle, alert-octagon, alert-triangle, aperture, arrow-down-circle, arrow-down-left, arrow-down-right, arrow-down, arrow-left-circle, arrow-left, arrow-right-circle, arrow-right, arrow-up-circle, arrow-up-left, arrow-up-right, arrow-up, at-sign, calendar, cast, check, chevron-down, chevron-left, chevron-right, chevron-up, chevrons-down, chevrons-left, chevrons-right, chevrons-up, circle, clipboard, clock, code, columns, command, compass, corner-down-left, corner-down-right, corner-left-down, corner-left-up, corner-right-down, corner-right-up, corner-up-left, corner-up-right, crosshair, database, divide-circle, divide-square, dollar-sign, download, external-link, feather, frown, hash, headphones, help-circle, info, italic, key, layout, life-buoy, link-2, link, loader, lock, log-in, log-out, maximize, meh, minimize, minimize-2, minus-circle, minus-square, minus, monitor, moon, more-horizontal, more-vertical, move, music, navigation-2, navigation, octagon, pause-circle, percent, plus-circle, plus-square, plus, power, radio, rss, search, server, share, shopping-bag, sidebar, smartphone, smile, square, table-2, tablet, target, terminal, trash-2, trash, triangle, tv, type, upload, x-circle, x-octagon, x-square, x, zoom-in, zoom-out
 *
 * The MIT License (MIT) (for the icons listed above)
 *
 * Copyright (c) 2013-present Cole Bemis
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
(() => {
  'use strict';

  if (window.TodayMerchMobileDesignEditor) return;

  const labels = {
    fr: { colors: 'Couleurs', title: 'Mon design', edit: 'Modifier mon design', close: 'Fermer', undo: 'Annuler', redo: 'Rétablir', done: 'Terminé', size: 'Taille', position: 'Position', rotation: 'Rotation', more: 'Plus', center: 'Centrer', duplicate: 'Dupliquer', delete: 'Supprimer', background: 'Retirer le fond', add: 'Ajouter un design', zones: 'Face et emplacement', artwork: 'Design sélectionné', hint: '1 doigt pour déplacer · 2 doigts pour agrandir', empty: 'Personnalisez cet emplacement', zoom: 'Zoom du produit', zoomIn: 'Agrandir la vue', zoomOut: 'Réduire la vue', fit: 'Vue entière', smaller: 'Réduire le design', larger: 'Agrandir le design', left: 'À gauche', right: 'À droite', up: 'En haut', down: 'En bas', controls: 'Réglages du design', zero: 'Remettre à 0°', unavailable: 'Aperçu indisponible pour ce fichier', failed: 'Cette action a échoué. Réessayez.' },
    en: { colors: 'Colors', title: 'My design', edit: 'Edit my design', close: 'Close', undo: 'Undo', redo: 'Redo', done: 'Done', size: 'Size', position: 'Position', rotation: 'Rotation', more: 'More', center: 'Center', duplicate: 'Duplicate', delete: 'Delete', background: 'Remove background', add: 'Add a design', zones: 'Side and placement', artwork: 'Selected design', hint: '1 finger to move · 2 fingers to resize', empty: 'Customize this placement', zoom: 'Product zoom', zoomIn: 'Zoom in on product', zoomOut: 'Zoom out on product', fit: 'Fit view', smaller: 'Make design smaller', larger: 'Make design larger', left: 'Left', right: 'Right', up: 'Up', down: 'Down', controls: 'Design settings', zero: 'Reset to 0°', unavailable: 'Preview unavailable for this file', failed: 'This action failed. Please try again.' },
    de: { colors: 'Farben', title: 'Mein Design', edit: 'Mein Design bearbeiten', close: 'Schließen', undo: 'Rückgängig', redo: 'Wiederholen', done: 'Fertig', size: 'Größe', position: 'Position', rotation: 'Drehung', more: 'Mehr', center: 'Zentrieren', duplicate: 'Duplizieren', delete: 'Löschen', background: 'Hintergrund entfernen', add: 'Design hinzufügen', zones: 'Seite und Position', artwork: 'Ausgewähltes Design', hint: '1 Finger: bewegen · 2 Finger: Größe ändern', empty: 'Diese Position gestalten', zoom: 'Produktzoom', zoomIn: 'Ansicht vergrößern', zoomOut: 'Ansicht verkleinern', fit: 'Gesamtansicht', smaller: 'Design verkleinern', larger: 'Design vergrößern', left: 'Links', right: 'Rechts', up: 'Oben', down: 'Unten', controls: 'Designeinstellungen', zero: 'Auf 0° zurücksetzen', unavailable: 'Keine Vorschau für diese Datei', failed: 'Die Aktion ist fehlgeschlagen. Bitte erneut versuchen.' },
    es: { colors: 'Colores', title: 'Mi diseño', edit: 'Editar mi diseño', close: 'Cerrar', undo: 'Deshacer', redo: 'Rehacer', done: 'Listo', size: 'Tamaño', position: 'Posición', rotation: 'Rotación', more: 'Más', center: 'Centrar', duplicate: 'Duplicar', delete: 'Eliminar', background: 'Quitar el fondo', add: 'Añadir un diseño', zones: 'Cara y ubicación', artwork: 'Diseño seleccionado', hint: '1 dedo para mover · 2 dedos para cambiar el tamaño', empty: 'Personaliza esta ubicación', zoom: 'Zoom del producto', zoomIn: 'Ampliar la vista', zoomOut: 'Reducir la vista', fit: 'Vista completa', smaller: 'Reducir el diseño', larger: 'Ampliar el diseño', left: 'Izquierda', right: 'Derecha', up: 'Arriba', down: 'Abajo', controls: 'Ajustes del diseño', zero: 'Volver a 0°', unavailable: 'Vista previa no disponible', failed: 'La acción ha fallado. Inténtalo de nuevo.' },
    it: { colors: 'Colori', title: 'Il mio design', edit: 'Modifica il mio design', close: 'Chiudi', undo: 'Annulla', redo: 'Ripristina', done: 'Fatto', size: 'Dimensioni', position: 'Posizione', rotation: 'Rotazione', more: 'Altro', center: 'Centra', duplicate: 'Duplica', delete: 'Elimina', background: 'Rimuovi sfondo', add: 'Aggiungi un design', zones: 'Lato e posizione', artwork: 'Design selezionato', hint: '1 dito per spostare · 2 dita per ridimensionare', empty: 'Personalizza questa posizione', zoom: 'Zoom del prodotto', zoomIn: 'Ingrandisci la vista', zoomOut: 'Riduci la vista', fit: 'Vista completa', smaller: 'Riduci il design', larger: 'Ingrandisci il design', left: 'Sinistra', right: 'Destra', up: 'Su', down: 'Giù', controls: 'Impostazioni del design', zero: 'Ripristina a 0°', unavailable: 'Anteprima non disponibile', failed: 'Azione non riuscita. Riprova.' },
    nl: { colors: 'Kleuren', title: 'Mijn ontwerp', edit: 'Mijn ontwerp bewerken', close: 'Sluiten', undo: 'Ongedaan', redo: 'Opnieuw', done: 'Klaar', size: 'Grootte', position: 'Positie', rotation: 'Rotatie', more: 'Meer', center: 'Centreren', duplicate: 'Dupliceren', delete: 'Verwijderen', background: 'Achtergrond verwijderen', add: 'Ontwerp toevoegen', zones: 'Zijde en plaatsing', artwork: 'Geselecteerd ontwerp', hint: '1 vinger: verplaatsen · 2 vingers: vergroten', empty: 'Personaliseer deze plaatsing', zoom: 'Productzoom', zoomIn: 'Weergave vergroten', zoomOut: 'Weergave verkleinen', fit: 'Volledige weergave', smaller: 'Ontwerp verkleinen', larger: 'Ontwerp vergroten', left: 'Links', right: 'Rechts', up: 'Omhoog', down: 'Omlaag', controls: 'Ontwerpinstellingen', zero: 'Terug naar 0°', unavailable: 'Geen voorbeeld voor dit bestand', failed: 'Deze actie is mislukt. Probeer opnieuw.' },
    pt: { colors: 'Cores', title: 'O meu design', edit: 'Editar o meu design', close: 'Fechar', undo: 'Anular', redo: 'Refazer', done: 'Concluído', size: 'Tamanho', position: 'Posição', rotation: 'Rotação', more: 'Mais', center: 'Centrar', duplicate: 'Duplicar', delete: 'Eliminar', background: 'Remover o fundo', add: 'Adicionar um design', zones: 'Lado e posição', artwork: 'Design selecionado', hint: '1 dedo para mover · 2 dedos para redimensionar', empty: 'Personalize esta posição', zoom: 'Zoom do produto', zoomIn: 'Ampliar a vista', zoomOut: 'Reduzir a vista', fit: 'Vista completa', smaller: 'Reduzir o design', larger: 'Ampliar o design', left: 'Esquerda', right: 'Direita', up: 'Cima', down: 'Baixo', controls: 'Definições do design', zero: 'Repor a 0°', unavailable: 'Pré-visualização indisponível', failed: 'Esta ação falhou. Tente novamente.' },
  };
  const mobileDesignIcons = {
    "x": [["path",{"d":"M18 6 6 18"}],["path",{"d":"m6 6 12 12"}]],
    "undo-2": [["path",{"d":"M9 14 4 9l5-5"}],["path",{"d":"M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5a5.5 5.5 0 0 1-5.5 5.5H11"}]],
    "redo-2": [["path",{"d":"m15 14 5-5-5-5"}],["path",{"d":"M20 9H9.5A5.5 5.5 0 0 0 4 14.5A5.5 5.5 0 0 0 9.5 20H13"}]],
    "zoom-out": [["circle",{"cx":"11","cy":"11","r":"8"}],["line",{"x1":"21","x2":"16.65","y1":"21","y2":"16.65"}],["line",{"x1":"8","x2":"14","y1":"11","y2":"11"}]],
    "zoom-in": [["circle",{"cx":"11","cy":"11","r":"8"}],["line",{"x1":"21","x2":"16.65","y1":"21","y2":"16.65"}],["line",{"x1":"11","x2":"11","y1":"8","y2":"14"}],["line",{"x1":"8","x2":"14","y1":"11","y2":"11"}]],
    "scan": [["path",{"d":"M3 7V5a2 2 0 0 1 2-2h2"}],["path",{"d":"M17 3h2a2 2 0 0 1 2 2v2"}],["path",{"d":"M21 17v2a2 2 0 0 1-2 2h-2"}],["path",{"d":"M7 21H5a2 2 0 0 1-2-2v-2"}]],
    "plus": [["path",{"d":"M5 12h14"}],["path",{"d":"M12 5v14"}]],
    "minus": [["path",{"d":"M5 12h14"}]],
    "maximize-2": [["path",{"d":"M15 3h6v6"}],["path",{"d":"m21 3-7 7"}],["path",{"d":"m3 21 7-7"}],["path",{"d":"M9 21H3v-6"}]],
    "move": [["path",{"d":"M12 2v20"}],["path",{"d":"m15 19-3 3-3-3"}],["path",{"d":"m19 9 3 3-3 3"}],["path",{"d":"M2 12h20"}],["path",{"d":"m5 9-3 3 3 3"}],["path",{"d":"m9 5 3-3 3 3"}]],
    "rotate-cw": [["path",{"d":"M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8"}],["path",{"d":"M21 3v5h-5"}]],
    "ellipsis": [["circle",{"cx":"12","cy":"12","r":"1"}],["circle",{"cx":"19","cy":"12","r":"1"}],["circle",{"cx":"5","cy":"12","r":"1"}]],
    "arrow-left": [["path",{"d":"m12 19-7-7 7-7"}],["path",{"d":"M19 12H5"}]],
    "arrow-up": [["path",{"d":"m5 12 7-7 7 7"}],["path",{"d":"M12 19V5"}]],
    "arrow-down": [["path",{"d":"M12 5v14"}],["path",{"d":"m19 12-7 7-7-7"}]],
    "arrow-right": [["path",{"d":"M5 12h14"}],["path",{"d":"m12 5 7 7-7 7"}]],
    "crosshair": [["circle",{"cx":"12","cy":"12","r":"10"}],["line",{"x1":"22","x2":"18","y1":"12","y2":"12"}],["line",{"x1":"6","x2":"2","y1":"12","y2":"12"}],["line",{"x1":"12","x2":"12","y1":"6","y2":"2"}],["line",{"x1":"12","x2":"12","y1":"22","y2":"18"}]],
    "rotate-ccw": [["path",{"d":"M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"}],["path",{"d":"M3 3v5h5"}]],
    "copy": [["rect",{"width":"14","height":"14","x":"8","y":"8","rx":"2","ry":"2"}],["path",{"d":"M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"}]],
    "palette": [["path",{"d":"M12 3a9 9 0 1 0 0 18h1.5a2.5 2.5 0 0 0 0-5H13a1.5 1.5 0 0 1 0-3h2.5A5.5 5.5 0 0 0 21 7.5C21 5 17 3 12 3Z"}],["circle",{"cx":"7.5","cy":"10","r":".75"}],["circle",{"cx":"11","cy":"7","r":".75"}],["circle",{"cx":"15.5","cy":"7.5","r":".75"}],["circle",{"cx":"7.5","cy":"14.5","r":".75"}]],
    "eraser": [["path",{"d":"M21 21H8a2 2 0 0 1-1.42-.587l-3.994-3.999a2 2 0 0 1 0-2.828l10-10a2 2 0 0 1 2.829 0l5.999 6a2 2 0 0 1 0 2.828L12.834 21"}],["path",{"d":"m5.082 11.09 8.828 8.828"}]],
    "trash-2": [["path",{"d":"M10 11v6"}],["path",{"d":"M14 11v6"}],["path",{"d":"M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"}],["path",{"d":"M3 6h18"}],["path",{"d":"M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"}]],
    "pencil-line": [["path",{"d":"M13 21h8"}],["path",{"d":"m15 5 4 4"}],["path",{"d":"M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z"}]],
    "image-plus": [["path",{"d":"M16 5h6"}],["path",{"d":"M19 2v6"}],["path",{"d":"M21 11.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7.5"}],["path",{"d":"m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"}],["circle",{"cx":"9","cy":"9","r":"2"}]]
  };
  const createIcon = (name) => {
    const namespace = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(namespace, 'svg');
    const attributes = {
      class: 'product-design-mobile-editor__icon',
      'data-lucide': name,
      width: '20', height: '20', viewBox: '0 0 24 24',
      fill: 'none', stroke: 'currentColor', 'stroke-width': '1.75',
      'stroke-linecap': 'round', 'stroke-linejoin': 'round',
      'aria-hidden': 'true', focusable: 'false',
    };
    Object.entries(attributes).forEach(([key, value]) => svg.setAttribute(key, value));
    mobileDesignIcons[name].forEach(([tag, attrs]) => {
      const node = document.createElementNS(namespace, tag);
      Object.entries(attrs).forEach(([key, value]) => node.setAttribute(key, value));
      svg.append(node);
    });
    return svg;
  };

  let instanceCount = 0;
  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
  const element = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  };

  window.TodayMerchMobileDesignEditor = class {
    constructor(owner) {
      this.owner = owner;
      this.inlineSupplierEditor = this.usesInlineSupplierEditor();
      this.id = `MobileDesignEditor-${++instanceCount}`;
      this.words = labels[(document.documentElement.lang || 'fr').split('-')[0]] || labels.en;
      this.media = window.matchMedia('(max-width: 1099.98px) and (pointer: coarse)');
      this.abort = new AbortController();
      this.pointers = new Map();
      this.zoom = 1;
      this.pan = { x: 0, y: 0 };
      this.activePanel = 'size';
      this.onMediaChange = () => {
        this.finishGesture();
        this.finishControl();
        this.syncPresentation();
        this.sync();
      };
      this.media.addEventListener('change', this.onMediaChange);
      this.entry = this.iconButton('edit', 'pencil-line', this.words.edit, this.words.edit);
      this.entry.className = 'product-design-mobile-editor-entry';
      this.entry.dataset.mobileDesignEntry = '';
      this.entry.setAttribute('aria-haspopup', 'dialog');
      this.entry.setAttribute('aria-controls', this.id);
      this.entry.hidden = true;
      this.entry.addEventListener('click', () => this.open({ opener: this.entry }), { signal: this.abort.signal });
      this.owner.append(this.entry);
      this.sync();
    }

    button(action, text, title = text) {
      const button = element('button', 'product-design-mobile-editor__button', text);
      button.type = 'button';
      button.dataset.mobileDesignAction = action;
      button.setAttribute('aria-label', title);
      return button;
    }

    iconButton(action, name, title, text = '') {
      const button = this.button(action, '', title);
      button.append(createIcon(name));
      if (text) button.append(element('span', 'product-design-mobile-editor__button-label', text));
      else button.classList.add('product-design-mobile-editor__button--icon');
      return button;
    }

    getSelector() {
      return this.owner.getProductRoot?.()?.querySelector('product-marking-selector') ||
        this.owner.closest('product-info, .section-main-product')?.querySelector('product-marking-selector');
    }

    usesInlineSupplierEditor() {
      if (typeof this.inlineSupplierEditor === 'boolean') return this.inlineSupplierEditor;
      const root = this.owner.closest('product-info') || this.owner.getProductRoot?.();
      return ['midocean', 'xd', 'pfconcept'].includes(root?.dataset.supplierPricing)
        || root?.dataset.personalizationExperience === 'xd-v2';
    }

    createDialog() {
      if (this.dialog) return;
      const w = this.words;
      const inline = this.usesInlineSupplierEditor();
      this.dialog = element(inline ? 'section' : 'dialog', 'product-design-mobile-editor');
      this.dialog.id = this.id;
      if (inline) {
        this.dialog.dataset.inlineSupplierDesignEditor = '';
        this.dialog.hidden = true;
      } else {
        this.dialog.dataset.mobileDesignDialog = '';
        this.dialog.setAttribute('aria-modal', 'true');
      }
      this.dialog.setAttribute('aria-labelledby', `${this.id}-title`);
      this.dialog.setAttribute('aria-describedby', `${this.id}-placement`);
      const header = element('header', 'product-design-mobile-editor__header');
      const heading = element('div', 'product-design-mobile-editor__heading');
      this.title = element('h2', 'product-design-mobile-editor__title', w.title);
      this.title.id = `${this.id}-title`;
      this.placementLabel = element('p', 'product-design-mobile-editor__placement');
      this.placementLabel.id = `${this.id}-placement`;
      heading.append(this.title, this.placementLabel);
      const history = element('div', 'product-design-mobile-editor__history');
      history.append(this.iconButton('undo', 'undo-2', w.undo), this.iconButton('redo', 'redo-2', w.redo));
      header.append(this.iconButton('close', 'x', w.close), heading, history);
      this.zones = element('nav', 'product-design-mobile-editor__zones');
      this.zones.setAttribute('aria-label', w.zones);
      this.canvas = element('div', 'product-design-mobile-editor__canvas');
      this.canvas.dataset.mobileDesignCanvas = '';
      this.slide = element('div', 'product__media-item');
      this.slide.dataset.mediaType = 'image';
      this.slide.dataset.mobileDesignSlide = '';
      this.slide.dataset.mobileDesignSurface = 'true';
      const container = element('div', 'product__media-item-container');
      const media = element('div', 'product__media');
      this.productImage = document.createElement('img');
      this.productImage.draggable = false;
      this.productImage.alt = '';
      media.append(this.productImage);
      container.append(media);
      this.slide.append(container);
      this.canvas.append(this.slide);
      this.empty = element('div', 'product-design-mobile-editor__empty');
      this.emptyMessage = element('p', '', w.empty);
      this.empty.append(this.emptyMessage, this.iconButton('add', 'image-plus', w.add, w.add));
      this.canvas.append(this.empty);
      const view = element('div', 'product-design-mobile-editor__view');
      const hint = element('p', 'product-design-mobile-editor__hint', w.hint);
      const camera = element('div', 'product-design-mobile-editor__camera');
      camera.setAttribute('role', 'group');
      camera.setAttribute('aria-label', w.zoom);
      this.zoomOutput = element('output', '', '100%');
      camera.append(this.iconButton('zoom-out', 'zoom-out', w.zoomOut), this.zoomOutput, this.iconButton('zoom-in', 'zoom-in', w.zoomIn), this.iconButton('fit', 'scan', w.fit));
      view.append(hint, camera);
      this.controls = element('div', 'product-design-mobile-editor__controls');
      this.artworkPicker = element('select', 'product-design-mobile-editor__artworks');
      this.artworkPicker.setAttribute('aria-label', w.artwork);
      this.artworkPicker.dataset.mobileDesignArtwork = '';
      this.controls.append(this.artworkPicker);
      const tabs = element('div', 'product-design-mobile-editor__tabs');
      tabs.setAttribute('role', 'tablist');
      tabs.setAttribute('aria-label', w.controls);
      ['size', 'position', 'rotation', 'more'].forEach((name) => {
        const tab = this.iconButton(`panel-${name}`, { size: 'maximize-2', position: 'move', rotation: 'rotate-cw', more: 'ellipsis' }[name], w[name], w[name]);
        tab.id = `${this.id}-tab-${name}`;
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', `${this.id}-panel-${name}`);
        tabs.append(tab);
      });
      this.controls.append(tabs);
      this.panels = {};
      ['size', 'position', 'rotation', 'more'].forEach((name) => {
        const panel = element('div', `product-design-mobile-editor__panel product-design-mobile-editor__panel--${name}`);
        panel.id = `${this.id}-panel-${name}`;
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', `${this.id}-tab-${name}`);
        this.panels[name] = panel;
        this.controls.append(panel);
      });
      this.sizeInput = this.range('size', w.size, 2, 400, 0.5);
      this.sizeOutput = element('output');
      this.panels.size.append(this.iconButton('smaller', 'minus', w.smaller), this.sizeInput.parentElement, this.iconButton('larger', 'plus', w.larger), this.sizeOutput);
      this.panels.position.append(this.iconButton('left', 'arrow-left', w.left), this.iconButton('up', 'arrow-up', w.up), this.iconButton('center', 'crosshair', w.center, w.center), this.iconButton('down', 'arrow-down', w.down), this.iconButton('right', 'arrow-right', w.right));
      this.rotationInput = this.range('rotation', w.rotation, -180, 180, 1);
      this.rotationOutput = element('output');
      this.panels.rotation.append(this.rotationInput.parentElement, this.rotationOutput, this.iconButton('zero-rotation', 'rotate-ccw', w.zero, '0°'));
      ['duplicate', 'colors', 'remove-background', 'delete'].forEach((action) => {
        const title = w[action === 'remove-background' ? 'background' : action];
        const button = this.iconButton(action, { duplicate: 'copy', colors: 'palette', 'remove-background': 'eraser', delete: 'trash-2' }[action], title, title);
        button.dataset.role = 'product-design-tool';
        if (action === 'colors') { button.setAttribute('aria-haspopup', 'dialog'); button.setAttribute('aria-expanded', 'false'); }
        this.panels.more.append(button);
      });
      const footer = element('footer', 'product-design-mobile-editor__footer');
      footer.append(this.button('done', w.done));
      this.status = element('p', 'product-design-mobile-editor__status');
      this.status.setAttribute('role', 'status');
      this.dialog.append(header, this.zones, this.canvas, view, this.controls, footer, this.status);
      // Keep the editing surface outside the gallery's media/variant indexes.
      if (inline) this.owner.after(this.dialog);
      else document.body.append(this.dialog);
      const { signal } = this.abort;
      this.dialog.addEventListener('click', (event) => this.click(event), { signal });
      this.dialog.addEventListener('cancel', (event) => { event.preventDefault(); this.cancelPendingPadPreparation(); this.close(); }, { signal });
      this.dialog.addEventListener('close', () => { if (this.context) this.close(); }, { signal });
      this.dialog.addEventListener('keydown', (event) => this.keydown(event), { signal });
      this.artworkPicker.addEventListener('change', () => {
        this.finishGesture();
        this.finishControl();
        if (!this.isCurrentContext()) { this.close(); return; }
        this.owner.setActiveDesignArtworkId(this.context.zone.key, this.artworkPicker.value);
        this.owner.renderDesignStudio();
        this.refresh();
      }, { signal });
      ['pointerdown', 'pointermove', 'pointerup', 'pointercancel', 'lostpointercapture'].forEach((type) => {
        this.canvas.addEventListener(type, (event) => this.pointer(event), { capture: true, signal });
      });
      this.canvas.addEventListener('click', (event) => {
        if (event.target.closest('[data-mobile-design-action]')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
      }, { capture: true, signal });
      this.productImage.addEventListener('load', () => this.refresh(), { signal });
      window.addEventListener('blur', () => { this.finishGesture(); this.finishControl(); }, { signal });
      document.addEventListener('visibilitychange', () => { if (document.hidden) { this.finishGesture(); this.finishControl(); } }, { signal });
      window.visualViewport?.addEventListener('resize', () => this.resize(), { signal });
      this.resizeObserver = new ResizeObserver(() => this.resize());
      this.resizeObserver.observe(this.canvas);
      this.syncPresentation();
      this.setPanel('size');
      this.owner.dispatchEvent(new CustomEvent('todaymerch:mobile-design-editor-ready', { bubbles: true, detail: { editor: this } }));
    }

    syncPresentation() {
      if (!this.dialog) return;
      const inline = this.usesInlineSupplierEditor();
      const desktop = !this.media.matches;
      this.dialog.dataset.designEditorLayout = inline ? 'inline' : desktop ? 'desktop' : 'mobile';
      this.title.textContent = desktop && !inline ? this.words.edit : this.words.title;
      const zone = this.context?.zone;
      this.placementLabel.textContent = zone?.label || zone?.emplacementLabel || '';
      this.placementLabel.hidden = !this.placementLabel.textContent;
      if (desktop && this.dialog.open && this.context?.supplierPlaneEditor) this.desktopPlaneSession = true;
    }

    range(name, title, min, max, step) {
      const label = element('label', 'product-design-mobile-editor__range');
      const caption = element('span', '', title);
      const input = document.createElement('input');
      input.type = 'range';
      input.min = min;
      input.max = max;
      input.step = step;
      input.dataset[name === 'size' ? 'mobileDesignSize' : 'mobileDesignRotation'] = '';
      label.append(caption, input);
      const { signal } = this.abort;
      input.addEventListener('pointerdown', () => this.startControl(name), { signal });
      input.addEventListener('input', () => this.updateControl(name, Number(input.value)), { signal });
      ['change', 'blur', 'pointerup', 'pointercancel'].forEach((type) => input.addEventListener(type, () => this.finishControl(), { signal }));
      return input;
    }

    requestOpen(request = {}) {
      const context = this.owner.getMobileDesignEditorContext(request.zoneKey);
      if (this.usesInlineSupplierEditor()) {
        if (this.destroyed || !context?.supplierPlaneEditor) return false;
        this.pending = { ...request };
        this.sync();
        return true;
      }
      if (this.destroyed || !this.media.matches && !context?.supplierPlaneEditor && !this.desktopPlaneSession) return false;
      this.pending = { ...request };
      this.sync();
      return true;
    }

    isCurrentContext() {
      return Boolean(this.context && String(this.context.variantId) === String(this.owner.activeVariantId || this.owner.designStudioState?.variantId || '')
        && this.owner.isDesignStudioStateForActiveVariant());
    }

    isCurrentInteraction(interaction) {
      if (!this.isCurrentContext()) return false;
      const zone = this.owner.designStudioState?.zones?.find((item) => item.key === interaction.zone.key);
      if (!zone) return false;
      if (interaction.artworkId !== this.owner.getBaseDesignArtworkId() && !this.owner.getDesignArtworkCopy(zone.key, interaction.artworkId)) return false;
      const source = this.owner.getDesignArtworkSource(zone, interaction.artworkId);
      return source.fileKey === interaction.fileKey && source.previewUrl === interaction.previewUrl;
    }

    sync() {
      if (this.destroyed || this.refreshing) return;
      const variantId = String(this.owner.activeVariantId || this.owner.designStudioState?.variantId || '');
      const zones = this.owner.designStudioState?.zones || [];
      const active = this.owner.getMobileDesignEditorContext();
      if (this.usesInlineSupplierEditor()) {
        this.entry.hidden = true;
        this.entry.style.display = '';
        // Photo-calibrated placements keep their direct gallery controls.
        // A supplier plane only needs its separate surface once it has a design.
        if (!active?.supplierPlaneEditor || !active.source?.previewUrl) {
          this.pending = null;
          this.close();
          return;
        }
        if (this.pending?.fileKey && (!this.pending.variantId || String(this.pending.variantId) === variantId)
          && (!this.pending.zoneKey || this.pending.zoneKey === active.zone.key)) {
          const item = active.artworks?.find(artwork => artwork.fileKey === this.pending.fileKey && artwork.previewUrl);
          if (item) this.owner.setActiveDesignArtworkId(active.zone.key, item.id);
        }
        this.pending = null;
        if (this.dialog?.open && this.context?.zone.key === active.zone.key && String(this.context.variantId) === variantId) {
          if (!this.gesture && !this.control) this.refresh();
        } else this.open({ zoneKey: active.zone.key });
        return;
      }
      const planeAvailable = active?.supplierPlaneEditor || this.pending && this.owner.getMobileDesignEditorContext(this.pending.zoneKey)?.supplierPlaneEditor;
      this.entry.hidden = !active?.supplierPlaneEditor && (!this.media.matches || !zones.some((zone) => zone.previewUrl || zone.artworks?.some((artwork) => artwork.previewUrl)));
      this.entry.style.display = active?.supplierPlaneEditor && !this.entry.hidden ? 'flex' : '';
      if (!this.media.matches && !planeAvailable && !this.desktopPlaneSession || (this.context && String(this.context.variantId) !== variantId)) {
        this.pending = null;
        this.close();
        return;
      }
      if (this.pending) {
        if (this.pending.variantId && String(this.pending.variantId) !== variantId) {
          this.pending = null;
        } else {
          const next = this.owner.getMobileDesignEditorContext(this.pending.zoneKey);
          const item = this.pending.fileKey ? next?.artworks?.find((artwork) => artwork.fileKey === this.pending.fileKey && artwork.previewUrl) : null;
          if (next && (item || (!this.pending.fileKey && (next.source?.previewUrl || this.pending.allowEmpty)))) {
            if (item) this.owner.setActiveDesignArtworkId(next.zone.key, item.id);
            const selected = this.owner.getMobileDesignEditorContext(next.zone.key);
            const preparedKey = `${selected.artworkId}|${selected.source.previewUrl}`;
            if (this.pending.preparedKey !== preparedKey) {
              this.pending.preparedKey = preparedKey;
              this.owner.renderDesignStudio({ slide: selected.slide, zone: selected.zone });
            }
            if (!selected.supplierPlaneEditor && selected.source?.previewUrl && !this.owner.isMobileDesignArtworkReady(selected)) return;
            const opener = this.pending.opener;
            this.pending = null;
            this.open({ zoneKey: next.zone.key, opener });
            return;
          }
        }
      }
      if (this.dialog?.open && !this.gesture && !this.control) this.refresh();
    }

    open({ zoneKey, opener } = {}) {
      const context = this.owner.getMobileDesignEditorContext(zoneKey);
      const inline = this.usesInlineSupplierEditor();
      if (inline && (!context?.supplierPlaneEditor || !context.source?.previewUrl)) return false;
      if (!context || this.destroyed || !this.media.matches && !context.supplierPlaneEditor && !this.desktopPlaneSession) return false;
      if (context.source?.previewUrl && !context.supplierPlaneEditor && !this.owner.isMobileDesignArtworkReady(context)) {
        return this.requestOpen({ variantId: context.variantId, zoneKey: context.zone.key, fileKey: context.source.fileKey, opener });
      }
      this.createDialog();
      this.finishGesture();
      this.finishControl();
      const newlyOpened = !this.dialog.open;
      if (newlyOpened) this.desktopPlaneSession = context.supplierPlaneEditor && !this.media.matches;
      const changed = this.context?.zone.key !== context.zone.key;
      this.context = context;
      this.syncPresentation();
      if (newlyOpened && inline) {
        this.status.textContent = '';
        this.dialog.open = true;
        this.dialog.setAttribute('open', '');
        this.dialog.hidden = false;
      } else if (newlyOpened) {
        this.status.textContent = '';
        const focused = document.activeElement;
        this.returnFocus = opener || (focused && focused !== document.body && focused !== document.documentElement
          && focused.getClientRects().length ? focused : this.entry);
        this.scrollPosition = { x: window.scrollX, y: window.scrollY };
        this.bodyStyle = { overflow: document.body.style.overflow, position: document.body.style.position, top: document.body.style.top, width: document.body.style.width };
        Object.assign(document.body.style, { overflow: 'hidden', position: 'fixed', top: `-${this.scrollPosition.y}px`, width: '100%' });
        this.dialog.showModal();
      }
      if (newlyOpened || changed) { this.zoom = 1; this.pan = { x: 0, y: 0 }; }
      this.refresh();
      this.layout();
      if ((newlyOpened || changed) && !inline) this.pulse();
      return true;
    }

    refresh() {
      if (!this.dialog?.open || this.refreshing || this.gesture || this.control) return;
      const next = this.owner.getMobileDesignEditorContext(this.context?.zone.key);
      if (!next || String(next.variantId) !== String(this.context?.variantId)) { this.close(); return; }
      this.refreshing = true;
      try {
        this.context = next;
        this.syncPresentation();
        this.slide.dataset.markingView = next.zone.viewKey || '';
        this.productImage.hidden = next.supplierPlaneEditor;
        this.dialog.dataset.supplierPlaneEditor = String(Boolean(next.supplierPlaneEditor));
        if (next.supplierPlaneEditor) this.productImage.removeAttribute('src');
        else if (this.productImage.getAttribute('src') !== next.productImage.src) this.productImage.src = next.productImage.src;
        this.productImage.alt = next.productImage.alt || '';
        this.productImage.style.objectFit = next.productImage.objectFit || 'contain';
        this.productImage.style.objectPosition = next.productImage.objectPosition || 'center';
        this.layout();
        this.overlay = this.owner.renderMobileDesignSurface(this.slide, next.zone);
        this.overlay?.querySelectorAll('[data-role="product-design-zone"], [data-role="product-design-artwork"], [data-role="product-design-artwork-copy"]').forEach((node) => node.tabIndex = -1);
        this.renderZones();
        this.renderArtworkPicker();
        this.updateControls();
        this.layout();
      } finally { this.refreshing = false; }
    }

    renderZones() {
      const profileOptions = this.getSelector()?.getStudioPlacementNavigationOptions?.();
      if (profileOptions?.length) {
        const source = this.owner.getProductRoot()?.querySelector('[data-personalization-v2-placement]');
        const subzones = [...source?.options || []].filter(option => !option.disabled);
        const signature = profileOptions.map(option => `${option.profileKey}:${option.emplacementLabel}:${option.active}`).join('|')
          + subzones.map(option => `${option.value}:${option.textContent}:${option.selected}`).join('|');
        if (signature !== this.zoneSignature) {
          this.zoneSignature = signature;
          this.zones.replaceChildren(...profileOptions.map(option => {
            const button = this.button('zone', option.emplacementLabel);
            button.dataset.mobileDesignZone = option.nativeZoneKey;
            button.dataset.profileKey = option.profileKey;
            button.setAttribute('aria-pressed', String(option.active === true));
            return button;
          }));
          if (subzones.length > 1) {
            const label = element('label', 'product-design-mobile-editor__button', 'Zone ');
            const select = element('select', 'product-design-mobile-editor__button');
            select.dataset.mobileDesignSubzone = ''; select.setAttribute('aria-label', 'Zone de marquage');
            select.replaceChildren(...subzones.map(option => option.cloneNode(true))); select.value = source.value;
            select.addEventListener('change', () => {
              this.finishGesture(); this.finishControl();
              this.getSelector()?.selectStudioPlacementCandidate(select.value);
              this.open({ zoneKey: this.owner.getActiveDesignZone()?.key });
            }, { signal: this.abort.signal });
            label.append(select); this.zones.append(label);
          }
        }
        return;
      }
      const zones = (this.owner.designStudioState?.zones || []).filter((zone) => zone.supportsLogo !== false
        && (zone.recommendedForPlacement !== false || zone.hasLogo));
      if (zones.some(zone => zone.emplacementKey)) {
        const groups = new Map();
        for (const zone of zones) {
          const key = zone.emplacementKey || zone.key;
          if (!groups.has(key)) groups.set(key, []);
          groups.get(key).push(zone);
        }
        const activeKey = this.context.zone.emplacementKey || this.context.zone.key;
        const signature = zones.map(zone => `${zone.key}:${zone.emplacementKey}:${zone.emplacementLabel}:${zone.label}`).join('|') + `|${this.context.zone.key}`;
        if (signature !== this.zoneSignature) {
          this.zoneSignature = signature;
          this.zones.replaceChildren(...[...groups].map(([key, choices]) => {
            const selected = choices.find(zone => zone.key === this.context.zone.key) || choices.find(zone => zone.hasLogo) || choices[0];
            const button = this.button('zone', selected.emplacementLabel || selected.label);
            button.dataset.mobileDesignZone = selected.key;
            button.setAttribute('aria-pressed', String(key === activeKey));
            return button;
          }));
          const choices = groups.get(activeKey) || [];
          if (choices.length > 1) {
            const label = element('label', 'product-design-mobile-editor__button', 'Zone ');
            const select = element('select', 'product-design-mobile-editor__button');
            select.dataset.mobileDesignSubzone = ''; select.setAttribute('aria-label', 'Zone de marquage');
            select.replaceChildren(...choices.map(zone => {
              const option = element('option', '', zone.label); option.value = zone.key;
              option.selected = zone.key === this.context.zone.key; return option;
            }));
            select.addEventListener('change', () => {
              this.finishGesture(); this.finishControl();
              const selector = this.getSelector();
              selector?.setActiveStudioZone(select.value, { selectInput: false, forceBroadcast: true });
              selector?.syncUI?.(); this.open({ zoneKey: select.value });
            }, { signal: this.abort.signal });
            label.append(select); this.zones.append(label);
          }
        }
        return;
      }
      const signature = zones.map((zone) => `${zone.key}:${zone.label}:${zone.viewKey}`).join('|');
      if (signature !== this.zoneSignature) {
        this.zoneSignature = signature;
        this.zones.replaceChildren(...zones.map((zone) => {
          const button = this.button('zone', zone.label || zone.viewKey || zone.key);
          button.dataset.mobileDesignZone = zone.key;
          return button;
        }));
      }
      this.zones.querySelectorAll('button').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.mobileDesignZone === this.context.zone.key)));
    }

    renderArtworkPicker() {
      const artworks = this.context.artworks || [];
      const signature = artworks.map((artwork) => `${artwork.id}:${artwork.fileName}`).join('|');
      if (this.artworkSignature !== signature) {
        this.artworkSignature = signature;
        this.artworkPicker.replaceChildren(...artworks.map((artwork, index) => {
          const option = element('option', '', `${index + 1}. ${artwork.fileName || this.words.title}`);
          option.value = artwork.id;
          return option;
        }));
      }
      this.artworkPicker.value = this.context.artworkId;
      this.artworkPicker.hidden = artworks.length < 2;
    }

    updateControls() {
      if (!this.context) return;
      const placement = this.owner.getDesignArtworkPlacement(this.context.zone, this.context.artworkId);
      const hasPreview = Boolean(this.context.source?.previewUrl);
      const ready = hasPreview && this.owner.isMobileDesignArtworkReady(this.context);
      const history = this.owner.getDesignArtworkHistory(this.context.zone.key, this.context.artworkId);
      this.empty.hidden = hasPreview;
      this.emptyMessage.textContent = this.context.source?.fileName ? this.words.unavailable : this.words.empty;
      this.controls.querySelectorAll('button, input').forEach((node) => { node.disabled = !ready || Boolean(this.busy); });
      this.dialog.querySelector('[data-mobile-design-action="colors"]').disabled = !this.context.source?.fileName || Boolean(this.busy);
      this.dialog.querySelector('[data-mobile-design-action="undo"]').disabled = !ready || !history?.past?.length || Boolean(this.busy);
      this.dialog.querySelector('[data-mobile-design-action="redo"]').disabled = !ready || !history?.future?.length || Boolean(this.busy);
      const pending = this.padPreparation()?.canConfirm?.() === false;
      this.dialog.querySelector('[data-mobile-design-action="done"]').textContent = pending
        ? (document.documentElement.lang.startsWith('en') ? 'Choose colours' : 'Choisir les couleurs') : this.words.done;
      this.updatePlacementControls(placement);
    }

    padPreparation() {
      const root = this.owner.closest('product-info');
      const preparation = window.TodayMerchPersonalizationOrchestrator?.get(root);
      const gate = window.TodayMerchPadPreparationGate;
      if (!gate?.read) return preparation;
      return {
        canConfirm: () => gate.read(root).canConfirm,
        focusPadPreparation: () => gate.read(root).focus?.(),
        cancelPadDraft: () => preparation?.cancelPadDraft?.(),
      };
    }

    cancelPendingPadPreparation() {
      const preparation = this.padPreparation();
      if (preparation?.canConfirm?.() === false) preparation.cancelPadDraft?.();
    }

    updatePlacementControls(placement) {
      const minimumFrameSize = this.owner.getDesignArtworkMinimumFrameSize?.(placement) || 2;
      const minimumWidth = placement.artworkRatio ? minimumFrameSize : 8;
      const minimumHeight = placement.artworkRatio ? minimumFrameSize : 5;
      this.sizeInput.min = Math.max(minimumWidth, placement.width * minimumHeight / Math.max(0.01, placement.height));
      this.sizeInput.max = Math.min(400, placement.width * 400 / Math.max(0.01, placement.height));
      if (this.control?.name !== 'size') this.sizeInput.value = placement.width;
      this.sizeOutput.textContent = `${Math.round(placement.width)}%`;
      if (this.control?.name !== 'rotation') this.rotationInput.value = placement.rotation || 0;
      this.rotationOutput.textContent = `${Math.round(placement.rotation || 0)}°`;
      this.sizeInput.setAttribute('aria-valuetext', this.sizeOutput.textContent);
      this.rotationInput.setAttribute('aria-valuetext', this.rotationOutput.textContent);
    }

    layout() {
      if (!this.dialog?.open || !this.context) return false;
      const height = window.visualViewport?.height;
      if (height) this.dialog.style.setProperty('--mobile-design-height', `${height}px`);
      const ratioText = String(this.context.productImage.aspectRatio || 1).split('/');
      const ratio = Number(ratioText[0]) / Number(ratioText[1] || 1) || 1;
      const width = Math.max(1, Math.min(this.canvas.clientWidth, this.canvas.clientHeight * ratio));
      const slideHeight = width / ratio;
      // CSS rounds serialized subpixel values. Comparing strings can report
      // an unchanged 358px height as a resize for 358.00000000000006px and
      // cancel a gesture when the first ResizeObserver notification arrives.
      const previousWidth = Number.parseFloat(this.slide.style.width);
      const previousHeight = Number.parseFloat(this.slide.style.height);
      const changed = !Number.isFinite(previousWidth) || !Number.isFinite(previousHeight)
        || Math.abs(previousWidth - width) > 0.01 || Math.abs(previousHeight - slideHeight) > 0.01;
      if (changed) {
        this.slide.style.width = `${width}px`;
        this.slide.style.height = `${slideHeight}px`;
      }
      this.applyCamera();
      return changed;
    }

    resize() {
      if (!this.layout()) return;
      this.finishGesture();
      this.finishControl();
      this.refresh();
    }

    applyCamera() {
      const maxX = Math.max(0, (this.slide.offsetWidth * this.zoom - this.canvas.clientWidth) / 2);
      const maxY = Math.max(0, (this.slide.offsetHeight * this.zoom - this.canvas.clientHeight) / 2);
      this.pan.x = clamp(this.pan.x, -maxX, maxX);
      this.pan.y = clamp(this.pan.y, -maxY, maxY);
      this.slide.style.transform = `translate(${this.pan.x}px, ${this.pan.y}px) scale(${this.zoom})`;
      this.zoomOutput.textContent = `${Math.round(this.zoom * 100)}%`;
      this.dialog.querySelector('[data-mobile-design-action="zoom-out"]').disabled = this.zoom <= 1;
      this.dialog.querySelector('[data-mobile-design-action="zoom-in"]').disabled = this.zoom >= 3;
    }

    pulse() {
      this.stopPulse();
      this.dialog.classList.add('is-zone-pulsing');
      this.pulseTimer = window.setTimeout(() => this.stopPulse(), 2000);
    }

    stopPulse() {
      window.clearTimeout(this.pulseTimer);
      this.dialog?.classList.remove('is-zone-pulsing');
    }

    setPanel(name) {
      this.activePanel = name;
      Object.entries(this.panels).forEach(([key, panel]) => { panel.hidden = key !== name; });
      this.dialog.querySelectorAll('[role="tab"]').forEach((tab) => {
        const selected = tab.dataset.mobileDesignAction === `panel-${name}`;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
    }

    keydown(event) {
      const tab = event.target.closest('[role="tab"]');
      if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const tabs = [...this.dialog.querySelectorAll('[role="tab"]')];
      const current = tabs.indexOf(tab);
      const index = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (current + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
      this.setPanel(tabs[index].dataset.mobileDesignAction.replace('panel-', ''));
      tabs[index].focus();
    }

    async click(event) {
      const button = event.target.closest('[data-mobile-design-action]');
      if (!button || button.disabled) return;
      const action = button.dataset.mobileDesignAction;
      if (action === 'close') { this.cancelPendingPadPreparation(); this.close(); return; }
      if (action === 'done') {
        this.finishGesture();
        this.finishControl();
        const preparation = this.padPreparation();
        if (preparation?.canConfirm?.() === false) {
          this.close();
          preparation.focusPadPreparation?.();
          return;
        }
        if (this.isCurrentContext()) {
          try { window.TodayMerchBrandStudioBridge?.emitProductPersonalized?.(this.dialog); } catch { /* Optional commercial signal. */ }
        }
        this.close();
        return;
      }
      if (!this.isCurrentContext()) { this.close(); return; }
      if (this.busy) return;
      this.finishGesture();
      this.finishControl();
      if (action.startsWith('panel-')) { this.setPanel(action.replace('panel-', '')); return; }
      if (action === 'zone') {
        const zoneKey = button.dataset.mobileDesignZone;
        const selector = this.getSelector();
        if (button.dataset.profileKey && typeof selector?.selectStudioPlacementCandidate === 'function') {
          selector.selectStudioPlacementCandidate(button.dataset.profileKey);
          this.open({ zoneKey: this.owner.getActiveDesignZone()?.key });
          return;
        }
        if (this.context.zone.key === zoneKey) return;
        selector?.setActiveStudioZone(zoneKey, { selectInput: false, forceBroadcast: true });
        selector?.syncUI?.();
        this.open({ zoneKey });
        return;
      }
      if (action === 'add') {
        const zoneKey = this.context.zone.key;
        this.close();
        const selector = this.getSelector();
        selector?.setActiveStudioZone(zoneKey, { selectInput: false });
        selector?.syncUI?.();
        selector?.openActiveLogoInput();
        return;
      }
      if (['zoom-in', 'zoom-out', 'fit'].includes(action)) {
        this.zoom = action === 'fit' ? 1 : clamp(this.zoom + (action === 'zoom-in' ? 0.25 : -0.25), 1, 3);
        if (action === 'fit') this.pan = { x: 0, y: 0 };
        this.applyCamera();
        return;
      }
      if (action === 'colors' && this.context.source?.fileName) {
        await this.owner.openDesignArtworkColors(this.context.zone, this.context.artworkId, button);
        return;
      }
      if (!this.context.source?.previewUrl || !this.owner.isMobileDesignArtworkReady(this.context)) return;
      this.stopPulse();
      const zone = this.context.zone;
      const artworkId = this.context.artworkId;
      const interaction = { zone, artworkId, fileKey: this.context.source.fileKey, previewUrl: this.context.source.previewUrl };
      if (!this.isCurrentInteraction(interaction)) { this.close(); return; }
      const placement = this.owner.getDesignArtworkPlacement(zone, artworkId);
      if (['left', 'right', 'up', 'down', 'zero-rotation', 'smaller', 'larger'].includes(action)) {
        this.owner.recordDesignArtworkHistory(zone.key, placement, artworkId);
        let next = { ...placement };
        if (action === 'smaller' || action === 'larger') next = this.scalePlacement(placement, action === 'smaller' ? 0.88 : 1.12);
        else if (action === 'zero-rotation') next = this.owner.fitDesignArtworkAfterRotation({ ...next, rotation: 0 }, zone, this.overlay);
        else next[action === 'left' || action === 'right' ? 'x' : 'y'] += action === 'left' || action === 'up' ? -1 : 1;
        this.owner.updateStoredDesignArtwork(zone.key, next, artworkId, { preferExistingPart: false, sizeLimitAttempt: action === 'larger' });
      } else {
        try {
          this.busy = true;
          this.status.textContent = '';
          this.updateControls();
          await this.owner.handleDesignArtworkTool({ preventDefault() {}, stopPropagation() {}, target: button }, this.overlay, action);
        } catch (error) {
          this.status.textContent = this.words.failed;
        } finally { this.busy = false; }
      }
      this.owner.renderDesignStudio();
      this.refresh();
    }

    startControl(name) {
      if (!this.isCurrentContext()) { this.close(); return; }
      if (!this.context?.source?.previewUrl || this.busy || !this.owner.isMobileDesignArtworkReady(this.context)) return;
      this.finishGesture();
      if (this.control) return;
      this.stopPulse();
      this.control = { name, zone: this.context.zone, artworkId: this.context.artworkId, fileKey: this.context.source.fileKey, previewUrl: this.context.source.previewUrl, placement: { ...this.owner.getDesignArtworkPlacement(this.context.zone, this.context.artworkId) }, artwork: this.overlay?.querySelector('[data-role="product-design-artwork"]'), recorded: false };
    }

    updateControl(name, value) {
      this.startControl(name);
      const control = this.control;
      if (!control) return;
      if (!this.isCurrentInteraction(control)) { this.finishControl(); this.sync(); return; }
      control.value = value;
      this.scheduleInteraction(control, () => this.renderControl(control));
    }

    setMobileOverlayManipulating(active) {
      this.overlay?.classList.toggle('is-manipulating', Boolean(active));
    }

    renderControl(control) {
      if (this.control !== control || !this.isCurrentInteraction(control)) return;
      const { name, value } = control;
      let next = { ...control.placement };
      if (name === 'size') {
        const scale = value / Math.max(0.01, control.placement.width);
        next = this.scalePlacement(control.placement, scale);
      } else next.rotation = value;
      if (!control.recorded) { this.owner.recordDesignArtworkHistory(control.zone.key, control.placement, control.artworkId); control.recorded = true; }
      this.setMobileOverlayManipulating(true);
      this.storePlacement(next, control);
    }

    finishControl() {
      const control = this.control;
      if (!control) return;
      this.flushInteraction(control);
      if (control.name === 'rotation' && control.pendingPlacement && this.isCurrentInteraction(control)) {
        const placement = this.owner.fitDesignArtworkAfterRotation(control.pendingPlacement, control.zone, this.overlay);
        this.owner.updateStoredDesignArtwork(control.zone.key, placement, control.artworkId, { preferExistingPart: true });
      }
      this.control = null;
      this.setMobileOverlayManipulating(false);
      this.owner.clearDesignAlignmentGuides(this.overlay);
      this.owner.renderDesignStudio();
      this.refresh();
    }

    scheduleInteraction(interaction, callback) {
      interaction.pendingFrame = callback;
      if (interaction.animationFrame) return;
      interaction.animationFrame = requestAnimationFrame(() => {
        interaction.animationFrame = null;
        const pending = interaction.pendingFrame;
        interaction.pendingFrame = null;
        pending?.();
      });
    }

    flushInteraction(interaction) {
      if (!interaction) return;
      if (interaction.animationFrame) cancelAnimationFrame(interaction.animationFrame);
      interaction.animationFrame = null;
      const pending = interaction.pendingFrame;
      interaction.pendingFrame = null;
      pending?.();
    }

    pointer(event) {
      if (!this.dialog.open || event.target.closest('[data-mobile-design-action]')) return;
      if (event.cancelable) event.preventDefault();
      event.stopImmediatePropagation();
      if (this.busy) return;
      if (!this.isCurrentContext()) { this.close(); return; }
      if (event.type === 'pointerdown') {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        this.finishControl();
        this.flushInteraction(this.gesture);
        this.stopPulse();
        const artwork = event.target.closest('[data-artwork-id]');
        if (!this.pointers.size && artwork?.dataset.artworkId) {
          this.owner.setActiveDesignArtworkId(this.context.zone.key, artwork.dataset.artworkId);
          this.owner.renderDesignStudio();
          this.refresh();
        }
        if (this.context.source?.previewUrl && !this.owner.isMobileDesignArtworkReady(this.context)) return;
        this.pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
        try { this.canvas.setPointerCapture?.(event.pointerId); } catch (error) { /* The pointer may already have ended. */ }
        if (!this.gesture) {
          this.gesture = { zone: this.context.zone, artworkId: this.context.artworkId, fileKey: this.context.source?.fileKey, previewUrl: this.context.source?.previewUrl, placement: { ...this.owner.getDesignArtworkPlacement(this.context.zone, this.context.artworkId) }, artwork: this.overlay?.querySelector('[data-role="product-design-artwork"]'), recorded: false, onArtwork: Boolean(artwork), preview: Boolean(this.context.source?.previewUrl) };
        }
        this.rebaseGesture();
      } else if (event.type === 'pointermove') {
        if (!this.pointers.has(event.pointerId) || !this.gesture) return;
        if (!this.isCurrentInteraction(this.gesture)) { this.finishGesture(); this.sync(); return; }
        this.pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
        this.scheduleInteraction(this.gesture, () => this.moveGesture());
      } else {
        if (!this.pointers.has(event.pointerId)) return;
        if (event.type === 'pointerup') {
          const point = this.pointers.get(event.pointerId);
          if (point.x !== event.clientX || point.y !== event.clientY) {
            this.pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
            this.scheduleInteraction(this.gesture, () => this.moveGesture());
          }
        }
        this.flushInteraction(this.gesture);
        this.pointers.delete(event.pointerId);
        if (event.type === 'pointercancel') { this.finishGesture(); return; }
        if (this.pointers.size) this.rebaseGesture();
        else this.finishGesture();
      }
    }

    rebaseGesture() {
      const gesture = this.gesture;
      if (!gesture) return;
      const points = [...this.pointers.values()];
      gesture.start = points;
      gesture.base = { ...this.owner.getDesignArtworkPlacement(gesture.zone, gesture.artworkId) };
      gesture.pan = { ...this.pan };
      const shell = this.overlay?.querySelector('[data-role="product-design-zone-shell"]');
      gesture.rect = this.owner.getDesignZoneShellRect?.(shell) || shell?.getBoundingClientRect();
      gesture.mode = points.length >= 2 && gesture.preview ? 'resize' : gesture.onArtwork && gesture.preview ? 'drag' : 'pan';
      if (gesture.mode === 'resize') {
        gesture.distance = Math.hypot(points[1].x - points[0].x, points[1].y - points[0].y);
        gesture.onArtwork = true;
      }
    }

    moveGesture() {
      const gesture = this.gesture;
      const points = [...this.pointers.values()];
      if (!gesture || !points.length || !gesture.rect?.width || !gesture.rect?.height) return;
      if (!this.isCurrentInteraction(gesture)) { this.finishGesture(); this.sync(); return; }
      let next = { ...gesture.base };
      if (gesture.mode === 'resize' && points.length >= 2) {
        const scale = Math.hypot(points[1].x - points[0].x, points[1].y - points[0].y) / Math.max(1, gesture.distance);
        next = this.scalePlacement(gesture.base, scale);
      } else if (gesture.mode === 'drag') {
        const screenX = points[0].x - gesture.start[0].x;
        const screenY = points[0].y - gesture.start[0].y;
        const delta = this.owner.projectDesignPointerDelta?.(screenX, screenY, gesture.rect.rotation || 0)
          || { x: screenX, y: screenY };
        next.x += delta.x / gesture.rect.width * 100;
        next.y += delta.y / gesture.rect.height * 100;
      } else {
        if (this.zoom > 1) {
          this.pan = { x: gesture.pan.x + points[0].x - gesture.start[0].x, y: gesture.pan.y + points[0].y - gesture.start[0].y };
          this.applyCamera();
        }
        return;
      }
      if (!gesture.recorded) { this.owner.recordDesignArtworkHistory(gesture.zone.key, gesture.placement, gesture.artworkId); gesture.recorded = true; }
      this.setMobileOverlayManipulating(true);
      this.storePlacement(next, gesture);
    }

    scalePlacement(placement, scale) {
      const width = Math.max(0.01, placement.width);
      const height = Math.max(0.01, placement.height);
      const minimumFrameSize = this.owner.getDesignArtworkMinimumFrameSize?.(placement) || 2;
      const minWidth = placement.artworkRatio ? minimumFrameSize : 8;
      const minHeight = placement.artworkRatio ? minimumFrameSize : 5;
      const bounded = clamp(scale, Math.max(minWidth / width, minHeight / height), Math.min(400 / width, 400 / height));
      return { ...placement, width: width * bounded, height: height * bounded };
    }

    storePlacement(placement, interaction) {
      if (!this.isCurrentInteraction(interaction)) { this.close(); return; }
      let rendered = placement;
      const rotation = interaction.name === 'rotation';
      if (rotation) {
        const resolved = this.owner.resolveDesignRotation(placement, { previousSnap: interaction.snappedRotation });
        rendered = resolved.placement;
        interaction.snappedRotation = resolved.snapped ? rendered.rotation : undefined;
        interaction.pendingPlacement = rendered;
        this.owner.updateDesignRotationGuides(this.overlay, rendered, resolved.snapped);
      } else {
        const previous = interaction.pendingPlacement || interaction.placement;
        const sizeLimitAttempt = (interaction.name === 'size' || interaction.mode === 'resize')
          && (placement.width > previous.width + 0.001 || placement.height > previous.height + 0.001);
        interaction.pendingPlacement = placement;
        this.owner.updateStoredDesignArtwork(interaction.zone.key, placement, interaction.artworkId, { preferExistingPart: interaction.mode !== 'drag', sizeLimitAttempt });
        rendered = this.owner.getDesignArtworkPlacement(interaction.zone, interaction.artworkId);
      }
      this.owner.updateDesignArtworkElement(interaction.artwork, rendered, interaction.zone, this.overlay, { transient: rotation });
      this.updatePlacementControls(rendered);
    }

    finishGesture() {
      this.flushInteraction(this.gesture);
      const active = Boolean(this.gesture);
      this.gesture = null;
      this.setMobileOverlayManipulating(false);
      const pointers = [...this.pointers.keys()];
      this.pointers.clear();
      pointers.forEach((id) => { if (this.canvas?.hasPointerCapture?.(id)) this.canvas.releasePointerCapture(id); });
      if (active) {
        this.owner.renderDesignStudio();
        this.refresh();
      }
    }

    close() {
      if (this.closing) return;
      this.closing = true;
      const wasOpen = this.dialog?.open;
      const inline = this.usesInlineSupplierEditor();
      this.pending = null;
      this.finishGesture();
      this.finishControl();
      this.stopPulse();
      if (this.dialog?.open) {
        if (inline) {
          this.dialog.open = false;
          this.dialog.removeAttribute('open');
          this.dialog.hidden = true;
        } else this.dialog.close();
      }
      this.context = null;
      this.desktopPlaneSession = false;
      if (this.bodyStyle) {
        Object.assign(document.body.style, this.bodyStyle);
        window.scrollTo(this.scrollPosition.x, this.scrollPosition.y);
        this.bodyStyle = null;
      }
      const returnFocus = this.returnFocus?.isConnected && this.returnFocus.getClientRects().length
        ? this.returnFocus
        : this.getSelector()?.querySelector('[data-role="studio-upload-empty"]');
      if (wasOpen && !inline) returnFocus?.focus({ preventScroll: true });
      this.returnFocus = null;
      this.closing = false;
    }

    destroy() {
      if (this.destroyed) return;
      this.close();
      this.destroyed = true;
      this.abort.abort();
      this.media.removeEventListener('change', this.onMediaChange);
      this.resizeObserver?.disconnect();
      if (this.slide) this.owner.designStudioOverlays?.delete(this.slide);
      this.dialog?.remove();
      this.entry.remove();
    }
  };
})();
